import vehiclesMetaReducer from './vehiclesMetaReducer';

export default vehiclesMetaReducer;
